// extracted by mini-css-extract-plugin
export default {"main_text":"styles_main_text__UqCVA","main_text_yellow":"styles_main_text_yellow__CZ1gx"};